import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "cmd00410-container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  class: "col flex justify-end",
  style: {"width":"100%"}
}
const _hoisted_6 = { class: "row q-gutter-x-sm" }
const _hoisted_7 = { class: "col-2" }
const _hoisted_8 = {
  key: 1,
  class: "q-mb-none q-ml-sm q-mt-sm"
}
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "row items-center cmd00410-table-upper" }
const _hoisted_11 = { class: "row items-center q-ml-xl q-gutter-x-sm rate-area" }
const _hoisted_12 = { class: "full-width row q-gutter-sm" }
const _hoisted_13 = { class: "q-pt-xs" }
const _hoisted_14 = { class: "table-suplliername" }
const _hoisted_15 = { class: "table-input-area" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col q-gutter-x-xs flex justify-end" }

import Loading from 'quasar/src/plugins/Loading.js';;
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import {
  isEmpty,
  isDecimalDigits,
  isHalfAlphanumeric,
  isTwoDecimalNumeric,
} from '../../common/utils/validateUtils';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import MessageChip from '../../components/chip/MessageChip.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import axios from '../../common/axios-common';
import DisplayModeCode from '../../common/code/DisplayModeCode';
import messages from '../../messages/message.json';

interface Props {
  // 登録・変更モード
  mode: string;
  // 得意先コード
  customerCd?: string;
}

// 掛け率のカテゴリー
interface Categories {
  category_id: string;
  rate: string;
  error: boolean;
  error_message: string;
}

// 掛け率マスタ
interface SupplierRate {
  supplier_code: string;
  supplier_name: string;
  category: Array<Categories>;
}

// 掛け率マスタ更新用
interface PriceFactor {
  supplier_code: string;
  category_id: string;
  rate: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00410',
  props: {
    mode: {},
    customerCd: {}
  },
  setup(__props: any) {

const router = useRouter();
const props = __props;

// MessageChip表示フラグ
const isMessageChip = ref(false);
// エラーメッセージ
const errMessage = ref('');
// 得意先コードの相関チェックエラー時
const customerCodeError = ref(false);
// 一括入力エリア
const batchInputRate = ref('');
// 一括入力の入力値がエラーかどうか
const batchInputError = ref(false);
// Dialogタイトル
const dialogTitle = ref('');
// Dialog表示レベル
const dialogLevel = ref('');
// Dialog本文
const dialogText = ref(['']);
// 確認Dialogフラグ
const isConfFlg = ref(false);
// 登録Dialog表示フラグ
const isRegisterDialogFlg = ref(false);
// 得意先掛け率を更新していいかどうかのフラグ
const submitFlg = ref(true);
// 初期表示読み込み時「データがありません」を非表示にするためのフラグ(falseで表示)
const hideNoDataFlg = ref(true);

// 得意先初期化用データ
const customerDataFormat = reactive({
  customer_code: '',
  customer_name: '',
  is_deleted: false,
});

// 得意先入力データ
const customerDataList = ref({ ...customerDataFormat });

// 表示カラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const columns = ref<any>([]);
// テーブル表示データ
const rateData = ref<Array<SupplierRate>>([]);

// 更新画面リセット用
const resetDataList = ref<Array<string>>([]);

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * 得意先掛け率新規登録 初期表示
 */
const registerInit = () => {
  Loading.show();

  axios
    .post('/cmd004101/search')
    .then((res) => {
      const { common, categoryList, supplierRateList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 掛け率テーブルのヘッダー情報（カテゴリー）を取得
          columns.value = categoryList;
          // 掛け率テーブルのサプライヤ情報を取得
          rateData.value = supplierRateList;
          break;

        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      Loading.hide();
      hideNoDataFlg.value = false;
    });
};

/**
 * 得意先掛け率更新 初期表示
 */
const updateInit = () => {
  Loading.show();

  const formData = new FormData();
  formData.append('customer_code', props.customerCd ? props.customerCd : '');

  axios
    .post('/cmd004102/search', formData)
    .then((res) => {
      const { common, categoryList, supplierRateList, customerData } = res.data;

      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 掛け率テーブルのヘッダー情報（カテゴリー）を取得
          columns.value = categoryList;
          // 掛け率テーブルのサプライヤ情報を取得
          rateData.value = supplierRateList;
          // 得意先情報を取得
          customerDataList.value = customerData;
          // リセット用の得意先データを格納
          Object.assign(customerDataFormat, customerData);
          // リセット用データ作成
          customerDataList.value.is_deleted = customerData.is_deleted !== '0';
          customerDataFormat.is_deleted = customerDataList.value.is_deleted;

          for (let f = 0; f < rateData.value.length; f += 1) {
            for (let b = 0; b < rateData.value[f].category.length; b += 1) {
              resetDataList.value.push(rateData.value[f].category[b].rate);
            }
          }
          break;

        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      Loading.hide();
      hideNoDataFlg.value = false;
    });
};

/**
 * rateDataの全てのrateのinputに一括入力inputの入力値を挿入
 */
const insertEachRateInput = () => {
  for (let i = 0; i < rateData.value.length; i += 1) {
    for (let t = 0; t < rateData.value[i].category.length; t += 1) {
      rateData.value[i].category[t].rate = Number(batchInputRate.value).toFixed(2);
      rateData.value[i].category[t].error = false;
      rateData.value[i].category[t].error_message = '';
    }
  }
};

/**
 * 一括入力ボタン押下時
 */
const pressBatchInputBtn = () => {
  // 一括入力欄を空にする
  errMessage.value = '';

  // エラーメッセージを非表示にする
  batchInputError.value = false;
  isMessageChip.value = false;

  // 入力値なしならチェックは行わない
  if (batchInputRate.value !== '') {
    if (!isDecimalDigits(batchInputRate.value)) {
      batchInputError.value = true;
      isMessageChip.value = true;
      errMessage.value = `${messages.ja.validation.half_numeric_only}`;
    } else if (parseInt(batchInputRate.value, 10) >= 10000) {
      batchInputError.value = true;
      isMessageChip.value = true;
      errMessage.value = `${messages.ja.validation.max_four_integer}`;
    } else if (!isTwoDecimalNumeric(batchInputRate.value)) {
      batchInputError.value = true;
      isMessageChip.value = true;
      errMessage.value = `${messages.ja.validation.two_decimal_places}`;
    } else {
      insertEachRateInput();
    }
  }
  window.scrollTo({ top: 0 });
};

/**
 * 登録確認ダイアログ表示
 */
const showRegisterConfirmDialog = () => {
  // 一括入力欄を空にする
  batchInputError.value = false;
  batchInputRate.value = '';

  if (props.mode === DisplayModeCode.REGISTER) {
    dialogTitle.value = '登録確認';
    dialogText.value = ['入力された内容で登録します。', 'よろしいですか？'];
  } else {
    dialogTitle.value = '更新確認';
    dialogText.value = ['入力された内容で更新します。', 'よろしいですか？'];
  }

  dialogLevel.value = 'information';
  isConfFlg.value = false;
  isRegisterDialogFlg.value = true;
  isMessageChip.value = false;
  errMessage.value = '';
};

/**
 * 掛け率の入力値チェック
 */
const checkEachRateInputValue = (inputValue: string) => {
  let error = false;
  let message = '';
  if (!isDecimalDigits(inputValue)) {
    error = true;
    message = `${messages.ja.validation.half_numeric_only}`;
    submitFlg.value = false;
  } else if (parseInt(inputValue, 10) >= 10000) {
    error = true;
    message = `${messages.ja.validation.max_four_integer}`;
    submitFlg.value = false;
  } else if (!isTwoDecimalNumeric(inputValue)) {
    error = true;
    message = `${messages.ja.validation.two_decimal_places}`;
    submitFlg.value = false;
  } else {
    error = false;
    message = '';
  }
  return { error, message };
};

/**
 * 得意先掛け率新規登録
 */
const registerInputValue = () => {
  Loading.show();
  isRegisterDialogFlg.value = false;
  const formData = new FormData();

  formData.append('customer_code', customerDataList.value.customer_code);
  formData.append('customer_name', customerDataList.value.customer_name);
  formData.append('is_deleted', customerDataList.value.is_deleted ? '1' : '0');

  const submitDataList = ref<Array<PriceFactor>>([]);
  // 掛け率入力値チェック
  submitFlg.value = true;
  for (let i = 0; i < rateData.value.length; i += 1) {
    for (let t = 0; t < rateData.value[i].category.length; t += 1) {
      const categoryPlace = rateData.value[i].category[t];
      // 入力値なしならControllerに渡さない
      if (categoryPlace.rate !== null && categoryPlace.rate !== '') {
        categoryPlace.rate = Number.isNaN(categoryPlace.rate)
          ? Number(categoryPlace.rate).toFixed(2)
          : categoryPlace.rate;
        // 入力値チェック結果を格納
        const checkResult = checkEachRateInputValue(categoryPlace.rate);
        if (checkResult.error) {
          categoryPlace.error = true;
          categoryPlace.error_message = checkResult.message;
        } else {
          const obj: PriceFactor = {
            supplier_code: rateData.value[i].supplier_code,
            category_id: categoryPlace.category_id,
            rate: categoryPlace.rate,
          };
          submitDataList.value.push(obj);
        }
      }
    }
  }

  // エラーがある場合は画面遷移を行わない
  if (submitFlg.value) {
    // 登録する掛け率情報設formにappend
    formData.append(`rateList`, JSON.stringify(submitDataList.value));

    axios
      .post('/cmd004101/register', formData)
      .then((res) => {
        const { common } = res.data;

        switch (common.status) {
          // 正常終了の場合
          case ResultStatusCode.SUCCESS:
            dialogTitle.value = '登録完了';
            dialogLevel.value = 'information';
            dialogText.value = ['登録が完了しました。'];
            isConfFlg.value = true;
            isRegisterDialogFlg.value = true;
            break;

          // エラーの場合
          case ResultStatusCode.ERROR:
            switch (common.detail_status) {
              case DetailResultStatusCode.DUPLICATE_CUSTOMER_ERROR:
              case DetailResultStatusCode.INSERT_ERROR:
                // 得意先コード入力エリアの枠を赤く（重複エラー）
                customerCodeError.value = true;
                // ダイアログ非表示
                isRegisterDialogFlg.value = false;
                isMessageChip.value = true;
                errMessage.value = [common.message].toString();
                break;

              // パラメータエラーの場合
              case DetailResultStatusCode.PARAMETER_ERROR:
                router.push({ name: 'error' });
                break;
              // システムエラーの場合
              case DetailResultStatusCode.SYSTEM_ERROR:
                router.push({ name: 'error' });
                break;
              default:
            }
            break;

          default:
            router.push({ name: 'error' });
        }
      })
      .catch((err) => {
        if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
          // セッションタイムアウトの場合
          router.push({ name: 'login', query: { timeout: 'timeout' } });
        } else {
          // その他エラーの場合
          router.push({ name: 'error' });
        }
      })
      .finally(() => {
        // Loading End
        Loading.hide();
        // TOPにスクロール
        setTimeout(() => window.scrollTo({ top: 0 }), 400);
      });
  } else {
    // Loading End
    Loading.hide();
    // ダイアログ非表示
    isRegisterDialogFlg.value = false;
    errMessage.value = messages.ja.message.MSG_50070E;
    isMessageChip.value = true;
    // TOPにスクロール
    setTimeout(() => window.scrollTo({ top: 0 }), 400);
  }
};

/**
 * 得意先掛け率更新
 */
const UpdateInputValue = () => {
  Loading.show();
  isRegisterDialogFlg.value = false;
  const formData = new FormData();

  formData.append('customer_code', customerDataList.value.customer_code);
  formData.append('customer_name', customerDataList.value.customer_name);
  formData.append('is_deleted', customerDataList.value.is_deleted ? '1' : '0');

  const submitDataList = ref<Array<PriceFactor>>([]);
  // 掛け率入力値チェック
  submitFlg.value = true;
  for (let i = 0; i < rateData.value.length; i += 1) {
    for (let t = 0; t < rateData.value[i].category.length; t += 1) {
      const categoryPlace = rateData.value[i].category[t];

      // 入力値なしならチェックは行わない
      if (categoryPlace.rate !== null && categoryPlace.rate !== '') {
        categoryPlace.rate = Number.isNaN(categoryPlace.rate)
          ? Number(categoryPlace.rate).toFixed(2)
          : categoryPlace.rate;
        // 入力値チェック結果を格納
        const checkResult = checkEachRateInputValue(categoryPlace.rate);
        if (checkResult.error) {
          categoryPlace.error = true;
          categoryPlace.error_message = checkResult.message;
        } else {
          const obj: PriceFactor = {
            supplier_code: rateData.value[i].supplier_code,
            category_id: categoryPlace.category_id,
            rate: categoryPlace.rate,
          };
          submitDataList.value.push(obj);
        }
      } else {
        const obj: PriceFactor = {
          supplier_code: rateData.value[i].supplier_code,
          category_id: categoryPlace.category_id,
          rate: categoryPlace.rate,
        };
        submitDataList.value.push(obj);
      }
    }
  }

  // エラーがある場合は画面遷移を行わない
  if (submitFlg.value) {
    // 更新する掛け率情報設formにappend
    formData.append(`rateList`, JSON.stringify(submitDataList.value));

    axios
      .post('/cmd004102/edit', formData)
      .then((res) => {
        const { common } = res.data;

        switch (common.status) {
          // 正常終了の場合
          case ResultStatusCode.SUCCESS:
            dialogTitle.value = '更新完了';
            dialogLevel.value = 'information';
            dialogText.value = ['更新が完了しました。'];
            // ダイアログを確認の状態に変更
            isConfFlg.value = true;
            // ダイアログを表示
            isRegisterDialogFlg.value = true;
            break;

          // エラーの場合
          case ResultStatusCode.ERROR:
            switch (common.detail_status) {
              case DetailResultStatusCode.UPDATE_ERROR:
                // ダイアログ非表示
                isRegisterDialogFlg.value = false;
                isMessageChip.value = true;
                errMessage.value = [common.message].toString();
                // TOPにスクロール
                setTimeout(() => window.scrollTo({ top: 0 }), 400);
                break;

              // パラメータエラーの場合
              case DetailResultStatusCode.PARAMETER_ERROR:
                router.push({ name: 'error' });
                break;
              // システムエラーの場合
              case DetailResultStatusCode.SYSTEM_ERROR:
                router.push({ name: 'error' });
                break;

              default:
            }
            break;
          default:
            router.push({ name: 'error' });
        }
      })
      .catch((err) => {
        if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
          // セッションタイムアウトの場合
          router.push({ name: 'login', query: { timeout: 'timeout' } });
        } else {
          // その他エラーの場合
          router.push({ name: 'error' });
        }
      })
      .finally(() => {
        Loading.hide();
        // TOPにスクロール
        setTimeout(() => window.scrollTo({ top: 0 }), 400);
      });
  } else {
    // Loading End
    Loading.hide();
    // ダイアログ非表示
    isRegisterDialogFlg.value = false;
    errMessage.value = messages.ja.message.MSG_50070E;
    isMessageChip.value = true;
    // TOPにスクロール
    setTimeout(() => window.scrollTo({ top: 0 }), 400);
  }
};

/**
 * 登録確認ダイアログのOK押下時
 */
const submitData = () => {
  Loading.show();

  // 得意先新規登録
  if (props.mode === DisplayModeCode.REGISTER) {
    registerInputValue();
  }
  // 得意先更新
  else {
    UpdateInputValue();
  }
};

/**
 * ダイアログのOKボタン押下時
 */
const closeDialog = () => {
  // エラーが無ければ得意先一覧画面に遷移
  if (dialogLevel.value === 'information') {
    router.replace({ name: 'customer' });
  } else {
    isRegisterDialogFlg.value = false;
  }
};

/**
 * 戻るボタン
 */
const backPage = () => {
  router.replace({ name: 'customer' });
};

/**
 * クリア（リセット）ボタン押下時
 */
const clearData = () => {
  // 得意先データ初期化
  customerDataList.value = { ...customerDataFormat };
  // 一括入力エリアの中身を初期化
  batchInputRate.value = '';
  // 一括入力欄を空にする
  errMessage.value = '';

  // エラーメッセージを非表示にする
  batchInputError.value = false;
  isMessageChip.value = false;

  if (props.mode === DisplayModeCode.REGISTER) {
    // 全部のデータの値を初期化
    for (let i = 0; i < rateData.value.length; i += 1) {
      for (let t = 0; t < rateData.value[i].category.length; t += 1) {
        rateData.value[i].category[t].rate = '';
        rateData.value[i].category[t].error = false;
        rateData.value[i].category[t].error_message = '';
      }
    }
  } else {
    // 全部のデータの値を初期表示のデータで上書き
    let roopCnt = 0;
    for (let i = 0; i < rateData.value.length; i += 1) {
      for (let t = 0; t < rateData.value[i].category.length; t += 1) {
        rateData.value[i].category[t].rate = resetDataList.value[roopCnt];
        rateData.value[i].category[t].error = false;
        rateData.value[i].category[t].error_message = '';
        roopCnt += 1;
      }
    }
  }
};

/**
 * 初期表示
 */
// propsが存在しない場合
if (!props.mode) {
  // 前画面に遷移
  backPage();
} else if (props.mode === DisplayModeCode.REGISTER) {
  // 得意先掛け率新規登録
  registerInit();
} else {
  // 得意先掛け率更新
  updateInit();
}

return (_ctx: any,_cache: any) => {
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => [
        (_ctx.mode === _unref(DisplayModeCode).REGISTER)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, "得意先および掛け率登録"))
          : _createCommentVNode("", true),
        (_ctx.mode === _unref(DisplayModeCode).CHANGE)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "得意先および掛け率変更"))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(MessageChip, {
      display: isMessageChip.value,
      level: "E",
      message: errMessage.value
    }, null, 8, ["display", "message"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_q_form, {
        greedy: "",
        "no-error-focus": "",
        onSubmit: _withModifiers(showRegisterConfirmDialog, ["prevent"]),
        onReset: clearData,
        onValidationError: resetError
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "cmd00410-input-form",
            style: _normalizeStyle(_ctx.mode === _unref(DisplayModeCode).CHANGE ? 'margin-top: -30px' : '')
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.mode === _unref(DisplayModeCode).CHANGE)
                  ? (_openBlock(), _createBlock(_component_q_toggle, {
                      key: 0,
                      modelValue: customerDataList.value.is_deleted,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customerDataList.value.is_deleted) = $event)),
                      label: "無効にする",
                      "left-label": "",
                      size: "lg"
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", {
                  class: _normalizeClass(_ctx.mode === _unref(DisplayModeCode).REGISTER && 'requier')
                }, "得意先コード", 2),
                (_ctx.mode === _unref(DisplayModeCode).REGISTER)
                  ? (_openBlock(), _createBlock(_component_q_input, {
                      key: 0,
                      modelValue: customerDataList.value.customer_code,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customerDataList.value.customer_code) = $event)),
                      outlined: "",
                      maxlength: "7",
                      dense: "",
                      "lazy-rules": "",
                      error: customerCodeError.value,
                      rules: [
                  (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
                  (val) => _unref(isHalfAlphanumeric)(val) || _ctx.$t('validation.half_alphanumeric_only'),
                ],
                      style: {"background":"var(--q-white)"},
                      class: "input-area",
                      onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                    }, null, 8, ["modelValue", "error", "rules"]))
                  : _createCommentVNode("", true),
                (_ctx.mode === _unref(DisplayModeCode).CHANGE)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(customerDataList.value.customer_code), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "requier" }, "得意先名｜納品場所", -1)),
                _createVNode(_component_q_input, {
                  modelValue: customerDataList.value.customer_name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customerDataList.value.customer_name) = $event)),
                  outlined: "",
                  maxlength: "100",
                  dense: "",
                  "lazy-rules": "",
                  rules: [(val) => _unref(isEmpty)(val) || _ctx.$t('validation.required')],
                  style: {"background":"var(--q-white)"},
                  class: "input-area",
                  onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                }, null, 8, ["modelValue", "rules"])
              ])
            ])
          ], 4),
          _createElementVNode("div", _hoisted_10, [
            _cache[12] || (_cache[12] = _createElementVNode("label", {
              class: "text-weight-bold",
              style: {"font-size":"1.1rem"}
            }, "掛け率情報", -1)),
            _createElementVNode("div", _hoisted_11, [
              _cache[11] || (_cache[11] = _createElementVNode("label", null, "掛け率", -1)),
              _createVNode(_component_q_input, {
                modelValue: batchInputRate.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((batchInputRate).value = $event)),
                outlined: "",
                dense: "",
                maxlength: "7",
                error: batchInputError.value,
                style: {"background":"var(--q-white)","width":"120px"},
                onBlur: _cache[6] || (_cache[6] = ($event: any) => (batchInputRate.value === '' ? (batchInputError.value = false) : '')),
                onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, null, 8, ["modelValue", "error"]),
              _createVNode(_component_q_btn, {
                outline: "",
                color: "primary",
                icon: "mdi-pencil",
                label: "一括入力",
                disabled: batchInputRate.value === '',
                onClick: pressBatchInputBtn
              }, null, 8, ["disabled"])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(
            'cmd00410-rate-table chem-table-area ' + (rateData.value.length === 0 ? 'table-nodata' : '')
          )
          }, [
            _createVNode(_component_q_table, {
              rows: rateData.value,
              columns: columns.value,
              "row-key": "supplier_code",
              flat: "",
              dense: "",
              separator: "cell",
              "rows-per-page-options": [10, 20, 50, 0],
              "hide-no-data": hideNoDataFlg.value,
              "no-data-label": "データがありません。",
              "rows-per-page-label": "件表示",
              "pagination-label": 
              (firstRowIndex, endRowIndex, totalRowsNumber) => {
                return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
              }
            
            }, {
              "no-data": _withCtx(({ message }) => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_q_icon, {
                    size: "24px",
                    name: "mdi-alert-circle-outline"
                  }),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(message), 1)
                ])
              ]),
              body: _withCtx((code) => [
                (!hideNoDataFlg.value)
                  ? (_openBlock(), _createBlock(_component_q_tr, {
                      key: 0,
                      props: code
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_td, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(code.row.supplier_code), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_q_td, null, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_14, _toDisplayString(code.row.supplier_name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(code.row.category, (category, index) => {
                          return (_openBlock(), _createBlock(_component_q_td, { key: index }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_q_input, {
                                  modelValue: category.rate,
                                  "onUpdate:modelValue": ($event: any) => ((category.rate) = $event),
                                  outlined: "",
                                  dense: "",
                                  maxlength: "7",
                                  "input-class": "text-right",
                                  "lazy-rules": "",
                                  error: category.error,
                                  "error-message": category.error_message,
                                  rules: [
                        (val) =>
                          !!val ? _unref(isDecimalDigits)(val) || _ctx.$t('validation.half_numeric_only') : true,
                        (val) =>
                          !!val
                            ? parseInt(val, 10) < 10000 || _ctx.$t('validation.max_four_integer')
                            : true,
                        (val) =>
                          !!val
                            ? _unref(isTwoDecimalNumeric)(val) || _ctx.$t('validation.two_decimal_places')
                            : true,
                      ],
                                  style: {"min-width":"100px","background":"var(--q-white)"},
                                  onKeydown: _cache[8] || (_cache[8] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                                  onFocus: ($event: any) => (category.error = false)
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "error-message", "rules", "onFocus"])
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["props"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["rows", "columns", "hide-no-data", "pagination-label"])
          ], 2),
          _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
            "button-area": _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_q_btn, {
                  color: "grey-7",
                  outline: "",
                  label: "戻る",
                  style: {"min-width":"120px","background":"var(--q-white) !important"},
                  onClick: backPage
                }),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_q_btn, {
                    type: "submit",
                    color: "primary",
                    style: {"width":"150px"},
                    label: _ctx.mode == _unref(DisplayModeCode).REGISTER ? '登録' : '変更'
                  }, null, 8, ["label"]),
                  _createVNode(_component_q_btn, {
                    outline: "",
                    type: "reset",
                    style: {"width":"150px","background":"var(--q-white) !important","color":"var(--q-delete)"},
                    icon: _ctx.mode == _unref(DisplayModeCode).REGISTER ? 'mdi-eraser' : 'cached',
                    label: _ctx.mode == _unref(DisplayModeCode).REGISTER ? 'クリア' : 'リセット'
                  }, null, 8, ["icon", "label"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(AlertDialog, {
      display: isRegisterDialogFlg.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: closeDialog,
      onConfirm: submitData,
      onClose: _cache[9] || (_cache[9] = ($event: any) => (isRegisterDialogFlg.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"])
  ]))
}
}

})